(() => {
  if (window.wltsV13Loaded) return;
  window.wltsV13Loaded = true;
  const originalCards = new WeakMap();
  function restoreCard(card) {
    const original = originalCards.get(card);
    if (!original) return;
    card.querySelector('[data-card-content]').replaceChildren(...original);
    originalCards.delete(card);
    card.querySelector('[data-sibling-status]').textContent = '';
  }
  function previewSibling(link) {
    const card = link.closest('[data-catalog-card]');
    const template = [...card.querySelectorAll('[data-sibling-template]')].find(el => el.dataset.siblingTemplate === link.dataset.siblingChoice);
    if (!template) return;
    const content = card.querySelector('[data-card-content]');
    if (!originalCards.has(card)) originalCards.set(card, [...content.childNodes]);
    content.replaceChildren(template.content.cloneNode(true));
    card.querySelector('[data-sibling-status]').textContent = link.dataset.siblingTitle + ' preview';
  }
  document.addEventListener('pointerover', event => {
    const link = event.target.closest('[data-sibling-choice]');
    if (!link || link.contains(event.relatedTarget) || event.pointerType === 'touch') return;
    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) previewSibling(link);
  });
  document.addEventListener('pointerout', event => {
    const link = event.target.closest('[data-sibling-choice]');
    if (link && !link.contains(event.relatedTarget)) restoreCard(link.closest('[data-catalog-card]'));
  });
  document.addEventListener('focusin', event => {
    const link = event.target.closest('[data-sibling-choice]');
    if (link?.matches(':focus-visible')) previewSibling(link);
  });
  document.addEventListener('focusout', event => {
    const link = event.target.closest('[data-sibling-choice]');
    if (link) restoreCard(link.closest('[data-catalog-card]'));
  });
  // Native links handle click, tap, modifier keys and opening in a new tab.
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-catalog-card]').forEach(restoreCard));

  const lens = document.createElement('div');
  lens.className = 'wlts-zoom-lens'; lens.hidden = true; lens.setAttribute('aria-hidden', 'true');
  document.body.append(lens);
  const dialog = document.createElement('dialog');
  dialog.className = 'wlts-image-lightbox'; dialog.setAttribute('aria-label', 'Enlarged product image');
  const fullImage = document.createElement('img');
  const close = document.createElement('button');
  close.type = 'button'; close.className = 'wlts-image-lightbox__close'; close.setAttribute('aria-label', 'Close enlarged image'); close.textContent = '×';
  dialog.append(fullImage, close); document.body.append(dialog);
  let opener, previousOverflow;
  function showImage(img) {
    if (dialog.open) return;
    lens.hidden = true; opener = img;
    fullImage.src = img.src; fullImage.alt = img.alt || 'Product image';
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal(); close.focus();
  }
  dialog.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  const mouseDevice = window.matchMedia('(min-width:992px) and (hover:hover) and (pointer:fine)');
  function initZoom(root = document) {
    root.querySelectorAll('[data-image-zoom="true"] .wlts-product-media__item img').forEach(img => {
      if (img.dataset.zoomImage) return;
      img.dataset.zoomImage = 'true'; img.tabIndex = 0; img.setAttribute('role', 'button');
      img.setAttribute('aria-label', 'Enlarge ' + (img.alt || 'product image'));
      img.setAttribute('aria-haspopup', 'dialog');
      let startX = 0, startY = 0, moved = false;
      img.addEventListener('pointerdown', e => {startX=e.clientX;startY=e.clientY;moved=false;});
      // The existing carousel captures the pointer on its container.
      img.closest('.wlts-product-media').addEventListener('pointermove', e => {
        if (e.buttons && Math.hypot(e.clientX-startX,e.clientY-startY)>8) moved=true;
      });
      img.addEventListener('click', e => {if (!e.defaultPrevented && !moved) showImage(img);});
      img.closest('.wlts-product-media').addEventListener('click', e => {
        // Pointer capture can retarget a stationary tap to the carousel itself.
        if (e.target !== e.currentTarget || e.defaultPrevented || moved) return;
        if (document.elementFromPoint(e.clientX,e.clientY) === img) showImage(img);
      });
      img.addEventListener('keydown', e => {if(e.key==='Enter'||e.key===' '){e.preventDefault();showImage(img);}});
      img.addEventListener('pointermove', e => {
        if (!mouseDevice.matches || e.pointerType !== 'mouse' || dialog.open) {lens.hidden=true;return;}
        const rect=img.getBoundingClientRect();
        if (!img.naturalWidth || !img.naturalHeight) return;
        const scale=Math.min(rect.width/img.naturalWidth,rect.height/img.naturalHeight);
        const width=img.naturalWidth*scale, height=img.naturalHeight*scale;
        const left=rect.left+(rect.width-width)/2, top=rect.top+(rect.height-height)/2;
        const x=e.clientX-left, y=e.clientY-top;
        if(x<0||x>width||y<0||y>height){lens.hidden=true;return;}
        const radius=110, zoom=2.5;
        lens.style.left=(e.clientX-radius)+'px';lens.style.top=(e.clientY-radius)+'px';
        lens.style.backgroundImage='url('+JSON.stringify(img.src)+')';
        lens.style.backgroundSize=(width*zoom)+'px '+(height*zoom)+'px';
        lens.style.backgroundPosition=(radius-x*zoom)+'px '+(radius-y*zoom)+'px';
        lens.hidden=false;
      });
      img.addEventListener('pointerleave',()=>{lens.hidden=true;});
    });
  }
  window.addEventListener('scroll',()=>{lens.hidden=true;},{passive:true});
  window.addEventListener('resize',()=>{lens.hidden=true;});
  document.addEventListener('shopify:section:load',e=>initZoom(e.target));
  document.addEventListener('shopify:section:unload',()=>{lens.hidden=true;if(dialog.open)dialog.close();});
  initZoom();
  function sizeShopRows(){
    document.querySelectorAll('.wlts-shop-section').forEach(section=>{
      const grid=section.querySelector('.wlts-shop-grid');if(!grid)return;
      const header=document.querySelector('.wlts-header');
      const headerHeight=header?.getBoundingClientRect().height||0;
      const main=document.querySelector('#MainContent');
      const mainTop=main?main.getBoundingClientRect().top+window.scrollY:0;
      const gridTop=grid.getBoundingClientRect().top+window.scrollY;
      const chrome=Math.max(headerHeight,gridTop-mainTop);
      const viewport=window.innerHeight;
      section.style.setProperty('--shop-row-height',Math.max(0,(viewport-chrome-1)/2)+'px');
    });
  }
  sizeShopRows();window.addEventListener('resize',sizeShopRows);
  document.addEventListener('shopify:section:load',sizeShopRows);
  if(window.ResizeObserver){const ro=new ResizeObserver(sizeShopRows);document.querySelectorAll('.wlts-header,.wlts-marquee,.wlts-shop-section > h1').forEach(el=>ro.observe(el));}
  document.fonts?.ready.then(sizeShopRows);
})();
